import React from 'react';
import PropTypes from 'prop-types';
import { Price } from '../price';
import { SetPriceIsMps } from '../set_price_is_mps';
import { getTranslationElement } from '../../../../helper/getTranslationElement';

export const SetPriceRow = props => (
    props.isMpsProduct ?
        <SetPriceIsMps
            name="product-single-item-price"
            label={showLabel(props) ? getTranslationElement(props.label, { quantity: props.quantity }, props.extraLabelProps) : null}
            price={buy4Pay3PriceOrRealPrice(props.hasBuy4Pay3, props.quantity, props.pricePerItem, props.discountPrice, props.hasDiscount)}
            currencyIsoCode={props.currencyIsoCode}
            overrides={{ decimalDigits: 2 }}
        />
        :
        <Price
            name={props.name}
            label={showLabel(props) ? getTranslationElement(props.label, { quantity: props.quantity }, props.extraLabelProps) : ''}
            price={buy4Pay3PriceOrRealPrice(props.hasBuy4Pay3, props.quantity, props.pricePerItem, props.discountPrice, props.hasDiscount)}
            currencyIsoCode={props.currencyIsoCode}
            hasPaddingBottom={props.hasPaddingBottom}
            labelExtraChildren={props.labelExtraChildren}
            overrides={{ decimalDigits: 2 }}
            className={props.className}
            hasBorder={!props.hideLabel}
            noBottomPadding={props.noBottomPadding}
        />
);

const extraChildrenPropType = PropTypes.arrayOf(PropTypes.element);

function showLabel(props) {
    return !props.hideLabel;
}

function buy4Pay3PriceOrRealPrice(hasBuyPay3, quantity, pricePerItem, discountPrice, hasDiscount) {
    let finalPrice = quantity * pricePerItem;
    if((hasBuyPay3 && quantity >= 4) || hasDiscount) {
        finalPrice -= discountPrice;
    }

    return finalPrice;
}

SetPriceRow.propTypes = {
    quantity: PropTypes.number.isRequired,
    pricePerItem: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    hasPaddingBottom: PropTypes.bool.isRequired,
    labelExtraChildren: extraChildrenPropType,
    extraLabelProps: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    hasBuy4Pay3: PropTypes.bool,
    hasDiscount: PropTypes.bool,
    discountPrice: PropTypes.number,
    isMpsProduct: PropTypes.bool,
};

SetPriceRow.defaultProps = {
    extraLabelProps: {},
    labelExtraChildren: [],
    label: 'pdp-sidebar-set-price',
    name: 'product-set-price',
    hasBuy4Pay3: false,
    hasDiscount: false,
    isMpsProduct: false,
};
